module.exports = __webpack_public_path__ + "static/media/DSC_0147.c65c846e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/DSC_0147.jpg
// module id = 637
// module chunks = 0